import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

// Görseller
import TMS from "../images/dmnglnakliyat3.jpg";
import img1 from "../images/dmnglnakliyat4.jpg";
import img2 from "../images/dmnglnakliyat5.jpg";
import img10 from "../images/dmnglnakliyat2.jpg";

// Bileşenler
import { Carousel } from "react-bootstrap"; 
import ProcessSection from "../Components/ProcessSection";
import Reviews from "../Components/Reviews";

// Türkçe karakterleri URL dostu slug metne çeviren yardımcı fonksiyon
const convertToSlug = (text) => {
  const map = { 'ç':'c', 'ğ':'g', 'ı':'i', 'i':'i', 'ö':'o', 'ş':'s', 'ü':'u', 'Ç':'c', 'Ğ':'g', 'İ':'i', 'Ö':'o', 'Ş':'s', 'Ü':'u' };
  const str = text.replace(/[çğıöşüÇĞİÖŞÜ]/g, (m) => map[m]);
  return str.toLowerCase().replace(/ /g, '-') + '-evden-eve-nakliyat';
};

const ilceler = [
  "Arnavutköy", "Avcılar", "Bağcılar", "Bahçelievler", 
  "Bakırköy", "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beylikdüzü", 
  "Beyoğlu", "Büyükçekmece", "Esenler", "Esenyurt", "Eyüpsultan", "Fatih", "Gaziosmanpaşa",
  "Güngören", "Kadıköy", "Kağıthane", "Küçükçekmece", "Sultangazi", "Şişli", "Zeytinburnu"
];

const HomePage = () => {
  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      {/* 1. SLIDER BÖLÜMÜ */}
      <section id="anasayfa" className="w-100">
        <Carousel>
          <Carousel.Item>
            <img src={img1} className="w-100" style={{ maxHeight: '500px', objectFit: 'cover' }} alt="Slide 1" />
            <Carousel.Caption>
              <h3 className="fw-bold text-white">DMNGL Nakliyata Hoşgeldiniz</h3>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img src={img10} className="w-100" style={{ maxHeight: '500px', objectFit: 'cover' }} alt="Slide 2" />
            <Carousel.Caption>
              <h3 className="fw-bold text-white">DMNGL Nakliyata Hoşgeldiniz</h3>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img src={TMS} className="w-100" style={{ maxHeight: '500px', objectFit: 'cover' }} alt="Slide 3" />
            <Carousel.Caption>
              <h3 className="fw-bold text-white">DMNGL Nakliyata Hoşgeldiniz</h3>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </section>

      {/* 2. HAKKIMIZDA BÖLÜMÜ */}
      <section id="hakkimizda" className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img src={img2} className="img-fluid rounded-3 shadow-sm" alt="About us" />
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-dark">DMNGL Nakliyat Hakkında</h2>
              <p className="text-muted leading-relaxed">
                DMNGL Nakliyat olarak, nakliye ve lojistik sektöründe yıllara dayanan tecrübemiz, geniş araç filomuz ve uzman kadromuzla evden eve nakliyat, iş yeri taşımacılığı ve şehirlerarası lojistik hizmetleri sunuyoruz. İstanbul Bahçelievler merkezli firmamız, eşyalarınızın her birini kendi eşyamız gibi benimseyerek taşınma sürecinin tüm stresini üzerinizden almayı hedeflemektedir.
              </p>
              <p className="text-muted leading-relaxed">
                Kurulduğumuz günden bu yana temel ilkemiz; zamanında teslimat, şeffaf fiyat politikası ve %100 müşteri memnuniyetidir. Modern nakliye standartlarına uygun olarak tasarlanmış geniş araç filomuz ve asansörlü taşıma sistemlerimiz sayesinde, en zorlu katlara dahi eşyalarınızı hasarsız ve hızlı bir şekilde ulaştırıyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. TAŞINMA SÜRECİ BÖLÜMÜ */}
      <section className="py-5 bg-light border-top border-bottom">
        <div className="container">
          <ProcessSection />
        </div>
      </section>

      {/* 4. PAKETLEME GALERİSİ (DÜZELTİLMİŞ TAM GENİŞLİK VE DÜZEN) */}
      <section className="py-5 bg-white w-100" style={{ display: 'block', clear: 'both' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          {/* ÜST BAŞLIK ALANI (TAM ORTADA VE GENİŞ) */}
          <div className="text-center w-100 mb-5" style={{ clear: 'both' }}>
            <span className="badge bg-primary-subtle text-primary fw-bold px-3 py-2 rounded-pill mb-2">
              ÖZENLİ AMBALAJLAMA
            </span>
            <h2 className="fw-bold text-dark display-6 mb-3">Profesyonel Paketleme Hizmetlerimiz</h2>
            <p className="text-muted fs-6 mx-auto" style={{ maxWidth: '700px' }}>
              Taşınma öncesinde eşyalarınızı darbeye, çizilmeye ve kirlenmeye karşı koruyucu özel ambalaj malzemeleriyle özenle paketliyoruz.
            </p>
          </div>

          {/* 4'LÜ KART DİZİLİMİ (INLINE FLEX - DARALMAZ VE TAŞMAZ) */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            marginRight: '-12px',
            marginLeft: '-12px',
            width: '100%'
          }}>
            {/* Kart 1 */}
            <div style={{ flex: '1 0 250px', padding: '0 12px', marginBottom: '24px', minWidth: '240px' }}>
              <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                <img 
                  src="/images/paketleme1.png" 
                  alt="Mobilya Ambalajlama" 
                  style={{ width: '100%', height: '220px', objectFit: 'cover' }} 
                />
                <div className="card-body bg-light text-center p-3">
                  <h5 className="fw-bold text-dark fs-6 mb-0">Mobilya Ambalajlama</h5>
                </div>
              </div>
            </div>

            {/* Kart 2 */}
            <div style={{ flex: '1 0 250px', padding: '0 12px', marginBottom: '24px', minWidth: '240px' }}>
              <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                <img 
                  src="/images/paketleme2.png" 
                  alt="Beyaz Eşya Koruması" 
                  style={{ width: '100%', height: '220px', objectFit: 'cover' }} 
                />
                <div className="card-body bg-light text-center p-3">
                  <h5 className="fw-bold text-dark fs-6 mb-0">Beyaz Eşya Koruması</h5>
                </div>
              </div>
            </div>

            {/* Kart 3 */}
            <div style={{ flex: '1 0 250px', padding: '0 12px', marginBottom: '24px', minWidth: '240px' }}>
              <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                <img 
                  src="/images/paketleme3.png" 
                  alt="Kırılacak Eşya Paketleme" 
                  style={{ width: '100%', height: '220px', objectFit: 'cover' }} 
                />
                <div className="card-body bg-light text-center p-3">
                  <h5 className="fw-bold text-dark fs-6 mb-0">Kırılacak Eşya Paketleme</h5>
                </div>
              </div>
            </div>

            {/* Kart 4 (Video) */}
            <div style={{ flex: '1 0 250px', padding: '0 12px', marginBottom: '24px', minWidth: '240px' }}>
              <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                <video 
                  src="/images/paketleme-video.mp4" 
                  style={{ width: '100%', height: '220px', objectFit: 'cover' }}
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                />
                <div className="card-body bg-light text-center p-3">
                  <h5 className="fw-bold text-dark fs-6 mb-0">Asansör Hizmetimiz </h5>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* 5. İSTANBUL İLÇELERİ SEO BÖLÜMÜ */}
      <section className="py-5 bg-light border-top">
        <div className="container">
          <div className="p-4 p-md-5 bg-white rounded-4 shadow-sm border">
            <div className="row align-items-center mb-4">
              <div className="col-lg-8">
                <h3 className="fw-bold text-dark h4 mb-2">
                  İstanbul Geneli Evden Eve Nakliyat & Taşımacılık Hizmet Bölgelerimiz
                </h3>
                <p className="text-muted small mb-0">
                  İstanbul Avrupa ve Anadolu yakasındaki tüm ilçelerde sigortalı, asansörlü ve ambalajlı evden eve nakliyat hizmeti veriyoruz. Bahçelievler merkezli araç filomuzla 39 ilçenin tamamına aynı gün ulaşmaktayız.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end mt-3 mt-lg-0">
                <a href="tel:05352439955" className="btn btn-primary fw-bold px-4 py-2 rounded-pill">
                  📞 Hemen Teklif Al
                </a>
              </div>
            </div>

            <hr className="my-4 text-muted opacity-25" />

            {/* İLÇE ETİKETLERİ */}
            <div className="d-flex flex-wrap gap-2">
              {ilceler.map((ilce, index) => (
                <Link 
                  key={index} 
                  to={`/${convertToSlug(ilce)}`}
                  className="btn btn-outline-dark btn-sm rounded-pill fw-normal px-3 py-2 border-opacity-25"
                  style={{ fontSize: '0.85rem' }}
                >
                  <strong className="fw-semibold">{ilce}</strong> Nakliyat
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 6. YORUM VE PUANLAMA BÖLÜMÜ */}
      <section id="yorumlar" className="py-5 bg-white">
        <div className="container">
          <Reviews />
        </div>
      </section>
    </div>
  );
};

export default HomePage;